const styles = (theme) => ({
  icon: {
    transform: 'translate(0, -3px)',
    fill: theme.color.grey_dark,
    marginRight: theme.spacing(1),
  },
  iconGreen: {
    transform: 'translate(0, -3px)',
    fill: theme.color.teal,
    marginRight: theme.spacing(1),
  },
  giftOptions: {
    display: 'flex',
    alignItems: 'center',
    color: theme.color.grey_dark,
  },
  options: {
    marginRight: theme.spacing(1),
    '& span': {
      margin: '0 2px',
    },
  },
});

export default styles;
